"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInvalidDomainError = exports.getBookInfoError = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var _reselect = require("reselect");

var _errors = require("MeetingsLib/constants/errors");

var getNetworkErrors = (0, _get.default)('networkErrors');

var getResponseJSON = function getResponseJSON(response) {
  if (!response) {
    return null;
  }

  if (response.responseJSON) {
    return response.responseJSON;
  }

  if (response.responseText) {
    var parsed = null;

    try {
      parsed = JSON.parse(response.responseText);
    } catch (e) {
      if (window.Raven) {
        window.Raven.captureException(e);
      }

      return parsed;
    }

    return parsed;
  }

  return null;
};

var getBookInfoError = (0, _reselect.createSelector)([getNetworkErrors], function (networkErrors) {
  var bookInfoError = (0, _get.default)('publicAvailabilityInfoFetch', networkErrors);
  var responseJSON = getResponseJSON(bookInfoError);
  return (0, _get.default)('errorType', responseJSON) || (0, _get.default)('message', responseJSON) || null;
});
exports.getBookInfoError = getBookInfoError;
var isInvalidDomainError = (0, _reselect.createSelector)([getBookInfoError], function (bookInfoError) {
  return bookInfoError === _errors.INVALID_DOMAIN_FOR_LINK;
});
exports.isInvalidDomainError = isInvalidDomainError;